module.exports = __webpack_public_path__ + "static/assistant-e2ff2fe83e32e79bcd0dad67228f342e.png";